import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setGlobalSearchModalVisible as setModalVisible } from 'actions';
import typewriter from 'lib/analytics/typewriter';
import useGlobalKey from 'lib/hooks/useGlobalKey';
import { getIsGlobalSearchModalVisible } from 'selectors';

/**
 * Hook for controlling global search functionality
 */
const useGlobalSearch = (disabled = false) => {
  const dispatch = useDispatch();
  const isGlobalSearchModalVisible = useSelector(getIsGlobalSearchModalVisible);

  const setGlobalSearchModalVisible = useCallback(
    (state: boolean) => dispatch(setModalVisible(state)),
    [dispatch],
  );

  // Register the command palette shortcut directly in the feature hook
  // This keeps the feature-specific keyboard shortcuts with their feature
  useGlobalKey('mod+k', (e) => {
    if (disabled) {
      return;
    }

    typewriter.searchOpened({ method: 'keyboard' });
    setGlobalSearchModalVisible(!isGlobalSearchModalVisible);
    e.preventDefault();
  });

  return {
    isGlobalSearchModalVisible,
    setGlobalSearchModalVisible,
  };
};

export default useGlobalSearch;
